import { render, staticRenderFns } from "./welcome-message.vue?vue&type=template&id=81715b4c&"
import script from "./welcome-message.vue?vue&type=script&lang=js&"
export * from "./welcome-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports